import React, { useEffect } from 'react';
import './StationProfile.scss';
import { featuresConfig as defaultFeaturesConfig } from '../../filters/Filters';
import { featuresConfig as teamFeaturesConfig } from '../../filters/FiltersTeam';
import { featuresConfig as vipFeaturesConfig } from '../../filters/FiltersVip';


export default function StationProfile({ station }) {
  const stationType = process.env.REACT_APP_STATION_TYPE;
  console.log("StationProfile → REACT_APP_STATION_TYPE =", stationType);
  const featuresConfig =
      stationType === 'TEAM'
          ? teamFeaturesConfig
          : stationType === 'VIP'
            ? vipFeaturesConfig
              : defaultFeaturesConfig;

  let {
    logo: {
      url: logo
    },
    address: {
      street,
      street_number,
      postal_code,
      city
    },
    station_number,
    google_maps_url,
    opening_hours,
    phone,
    warning,
    features,
    name
  } = station;

  if (process.env.REACT_APP_STATION_TYPE !== "B2B") {
    delete station.features.stations.partner;
  }

  useEffect(() => {
    window.parent.postMessage({
      type: 'open-station',
      data: { name }
    }, '*');

    return () => {
      window.parent.postMessage({
        type: 'close-station',
        data: { name }
      }, '*');
    };
  }, []);

  return (
    <div className="station-profile">
      <div className="station-profile__head">
        <img className="station-profile__logo" src={`${process.env.REACT_APP_API_URL}${logo}`} alt="logo" />
        <div className="station-profile__address">
          <strong>{city}</strong>
          <span>{street}</span>
        </div>
        <div className="station-profile__number">
          <span>Numer stacji</span>
          <strong>{station_number}</strong>
        </div>
      </div>
      {Boolean(features.stations.avia_truck) ? (<div className="station-profile__partner-container">
        <img src="/images/icons/stations/avia-truck.svg" alt="Stacja AVIA Truck" />
        <div className=''>
          <div className='station-profile__partner'>AVIA Truck</div>
        </div>
      </div>) : null}
      <div className='station-profile__border-bottom' />
      <div className="station-profile__content">
        <div className="station-profile__left-col">
          <div className={`station-list-item__hours ${opening_hours.is_24h ? 'station-list-item__hours--24h' : ''}`}>
            <img src="/images/icons/common/clock.svg" alt="Ikona zegara" />
            {opening_hours.is_24h ? '24h' : (
              <>
                {!!opening_hours.working_days_start && <>pon-pt: {opening_hours.working_days_start.slice(0, 5)} - {opening_hours.working_days_end.slice(0, 5)}<br /></>}
                {!!opening_hours.saturday_start && <>sob: {opening_hours.saturday_start.slice(0, 5)} - {opening_hours.saturday_end.slice(0, 5)}<br /></>}
                {!!opening_hours.sunday_start && <>niedz: {opening_hours.sunday_start.slice(0, 5)} - {opening_hours.sunday_end.slice(0, 5)}<br /></>}
              </>
            )}
          </div>
          <div className="station-profile__full-address">
            <img src="/images/icons/common/location.svg" alt="Ikona telefonu" />
            {street} {street_number}<br />
            {postal_code}<br />
            {city}
          </div>
          <div className="station-profile__tel">
            <img src="/images/icons/common/phone.svg" alt="Ikona telefonu" />
            <a href={`tel:${phone}`}>{phone}</a>
          </div>
        </div>
        <div className="station-profile__right-col">
          <div className="station-profile__drive">
            <a className="station-profile__drive-button" href={google_maps_url} target="_blank" rel="noreferrer">
              Jak dojechać
              <img src="/images/icons/common/arrow-top-right.svg" alt="Strzałka" />
            </a>
          </div>
        </div>
        {!!warning && (
          <div className="station-profile__alert">
            <img src="/images/icons/common/warning.svg" alt="Ikona alertu" />
            <p>{warning}</p>
          </div>
        )}
        <div className="station-profile__features">
          {featuresConfig.map((featureConfig) => (
            Boolean(featureConfig.key !== 'stations') ?
              <React.Fragment key={featureConfig.key}>
                <h3 className="station-profile__features-head">{featureConfig.name}</h3>
                <ul className="station-profile__features-list">
                  {
                    featureConfig.items
                      .filter(item => features[featureConfig.key][item.id])
                      .map(item => (
                        <li key={item.id}>
                          <img src={item.icon} alt={item.label} />
                          {item.label}
                        </li>
                      ))
                  }
                </ul>
              </React.Fragment>
            : null
          ))}
        </div>
      </div>
    </div>
  );
}
